import { arrayOf, bool, number, objectOf, shape, string } from 'prop-types';
import { PAGE_NAME } from '../../utils/bigQueryEventsData';

/**
 * @property MACHINE_TRANSLATION_PREVIEW - preview status that shows banner
 * with languages selector and entry point to start translating for chosen language
 * @property BEFORE_PUBLISH - preview status that shows banner that indicates
 * translation layer is created and user can review translations on own gig page
 * @property READY_TRANSLATION_LAYER - preview status that shows banner that indicates
 * translation layer is ready and user can review active translations on own gig page
 */
export const LOCAL_CATALOG_PREVIEW_STATES = {
    MACHINE_TRANSLATION_PREVIEW: 'mt_preview',
    BEFORE_PUBLISH: 'before_publish',
    READY_TRANSLATION_LAYER: 'ready_tl',
};

export const SELLER_COUPON_TYPES = {
    COUPON: 'seller-coupons',
    PROMOTION: 'seller-promotions',
};

export const PROMOTIONS_VIEWED_LOCAL_STORAGE_KEY = 'promotions-viewed-4260';

export const NON_EXP_BQ_PACKAGE_TABLE_SHOW_PARAMS = {
    type: 'gig_compare_packages_is_shown',
    entity: 'client',
    group: 'user_impression',
    action: { type: 'impression' },
    page: {
        name: PAGE_NAME,
        component: {
            name: 'gig_compare_packages',
        },
    },
};

export const BQ_DSA_NONCOMPLIANT_INTERACTION_STOPPED = {
    type: 'dsa_non_compliant_interaction_stopped',
    entity: 'client',
    group: 'user_impression',
    action: { type: 'impression' },
    page: {
        name: PAGE_NAME,
    },
};

export const SellerHourlyEligibilityPropType = shape({
    sellerHourlyEligible: bool,
});

export const SellerCardPropType = shape({
    achievement: number.isRequired,
    countryCode: string.isRequired,
    description: string.isRequired,
    hasProfilePhoto: bool.isRequired,
    isPro: bool.isRequired,
    memberSince: number.isRequired,
    oneLiner: string.isRequired,
    proSubCategories: arrayOf(string).isRequired,
    proficientLanguages: arrayOf(objectOf(string)).isRequired,
    profilePhoto: string.isRequired,
    rating: number.isRequired,
    ratingsCount: number.isRequired,
    recentDelivery: number.isRequired,
    responseTime: number.isRequired,
});
